import type { SlotProps } from 'input-otp';

export enum LiliOtpType {
  NUMERIC = 'numeric',
  ALPHABETIC = 'alphabetic',
  ALPHANUMERIC = 'alphanumeric',
  CUSTOM = 'custom',
}

interface BaseLiliOtpProps extends Omit<
  React.InputHTMLAttributes<HTMLInputElement>,
  'onChange' | 'children' | 'className'
> {
  maxLength: number;
  value?: string;
  onCompleted?: (otp: string) => void;
  id: string;
  disabled?: boolean;
  errorMessage?: string;
  onFocus?: () => void;
  onBlur?: () => void;
  onChange?: (otp: string) => void;
  autoFocus?: boolean;
  className?: string;
}

interface CustomLiliOtpProps extends BaseLiliOtpProps {
  type: LiliOtpType.CUSTOM;
  pattern: string; // Mandatory when type is CUSTOM
}

interface NonCustomLiliOtpProps extends BaseLiliOtpProps {
  type?: Exclude<LiliOtpType, LiliOtpType.CUSTOM>; // Any type except CUSTOM
  pattern?: string; // Optional for other types
}

export type LiliOtpProps = CustomLiliOtpProps | NonCustomLiliOtpProps;

export interface ExtendedSlotProps extends SlotProps {
  error?: boolean;
}
